import { render, staticRenderFns } from "./cardgroups.vue?vue&type=template&id=440a260c"
import script from "./cardgroups.vue?vue&type=script&lang=js"
export * from "./cardgroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports